module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "other-news"
  }, [_c('news-heading', {
    attrs: {
      "subtitle": true,
      "id": "external",
      "noMargin": true
    }
  }, [_vm._v("Other News Companies")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".item"
    }
  }, _vm._l((_vm.allPosts), function(post) {
    return _c('news-external', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      key: post.id,
      attrs: {
        "post": post
      }
    })
  })), _vm._v(" "), (_vm.posts.length) ? _c('div', {
    staticClass: "news-button-container"
  }, [(!_vm.finished) ? _c('button', {
    staticClass: "news-button",
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n            Show More\n            "), (_vm.loading) ? _c('loading-icon') : _vm._e()], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53662269"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/other-news.vue
// module id = 178
// module chunks = 4